module.exports = __webpack_public_path__ + "img/Eu.9dee6ba1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Eu.jpg
// module id = sM6P
// module chunks = 1